/* eslint-disable no-unreachable */
import React, { useState, useEffect } from 'react'
import { styled } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import BeatLoader from 'react-spinners/BeatLoader'
import { withNamespaces } from 'react-i18next'
import i18n from '../language/localization'
import Cookies from 'universal-cookie'
import {
  getCostCentersByUser,
  getDepartmentsByUser,
  getGLAccountsByUser,
  getInfoByUser
} from '../../api/authorization'
import { addCodeNumber } from '../../utils/addCodeNumberPhone'
import { useAuth } from '../../hooks/useAuth'
import { Box, Button, Link, Snackbar } from '@mui/material'
import { loginUseStyles } from './Login.style'
import { Visibility, VisibilityOff } from 'components/Icons'
import Loading from 'components/common/Loading'

const IconButtonStyled = styled(IconButton)({
  padding: '0px !important',
  marginRight: '-4px !important',
  position: 'absolute',
  top: 0,
  right: 8
})

const Form = () => {
  const auth = useAuth()

  const [login, setLogin] = React.useState({
    user: '',
    password: '',
    department: ''
    // costCenter: ''
  })
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => {
    if (showPassword) {
      setShowPassword(false)
    } else {
      setShowPassword(true)
    }
  }
  const handleChangeLogin = e => {
    let value = e.target.value

    if (e.target.name === 'user') {
      setUserInfo(null)
      setDepartmentList([])
      setCostCenterList([])
      setGlAccountList([])

      value = String(value).toLowerCase()
    }
    setLogin({ ...login, [e.target.name]: value })
  }
  const [loginMessage, setloginMessage] = useState(false)
  const [loginMessageValue, setloginMessageValue] = useState(false)
  const cookies = new Cookies()

  const [open1, setOpen1] = useState(false)
  const [check, setCheck] = useState(false)

  const [departmentList, setDepartmentList] = useState([])
  const [, setCostCenterList] = useState([])
  const [glAccountList, setGlAccountList] = useState([])
  const [loadingDepartment, setLoadingDepartment] = useState(false)
  const [, setLoadingCostCenter] = useState(false)
  const [userInfo, setUserInfo] = useState(null)
  const [loadingUserInfo, setLoadingUserInfo] = useState(false)

  const handleGetInfo = async () => {
    if (!login.user) return
    setLoadingUserInfo(true)
    try {
      const response = await getInfoByUser(login.user)
      if (!response.success) {
        setloginMessage(true)
        setloginMessageValue(response.data || response.message)
        return
      }
      setUserInfo(response.data)
      console.log('response', response)
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingUserInfo(false)
    }
  }

  const handleGetDepartment = async () => {
    if (!login.user) return
    setLoadingDepartment(true)
    try {
      const response = await getDepartmentsByUser(login.user)
      if (!response.success) {
        setloginMessage(true)
        setloginMessageValue(response.data || response.message)
        return
      }
      setDepartmentList(response.data)
      if (response.data.length === 1) {
        setLogin({
          ...login,
          department: response.data[0].department.id
        })
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingDepartment(false)
    }
  }

  const handleGetCostCenter = async () => {
    if (!login.user) return
    setLoadingCostCenter(true)
    try {
      const response = await getCostCentersByUser(login.user)
      if (!response.success) {
        setloginMessage(true)
        setloginMessageValue(response.data || response.message)
        return
      }
      setCostCenterList(response.data)
      if (response.data.length === 1) {
        setLogin({
          ...login,
          costCenter: response.data[0].cost_center.id
        })
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingCostCenter(false)
    }
  }

  const handleGetGLAccount = async () => {
    if (!login.user) return
    try {
      const response = await getGLAccountsByUser(login.user)
      if (!response.success) {
        setloginMessage(true)
        setloginMessageValue(response.data || response.message)
        return
      }
      setGlAccountList(response.data)
    } catch (error) {
      console.error(error)
    }
  }

  const Login = async event => {
    event.preventDefault()
    setOpen1(true)
    let user = login.user
    let password = login.password

    if (user && password) {
      const data = {
        user: addCodeNumber(user),
        password: password
      }

      const response = await auth.login(data.user, data.password)

      if (!response.success) {
        setloginMessage(true)
        setloginMessageValue(response.data || response.message)
      } else {
        if (check) {
          cookies.set('remember', 'true')
          cookies.set('user', login.user)
          cookies.set('password', login.password)
        } else {
          cookies.remove('remember')
          cookies.remove('user')
          cookies.remove('password')
        }

        const selectedDepartment = departmentList.find(
          department => department.department.id == login.department
        )
        // const selectedCostCenter = costCenterList.find(
        //   costCenter => costCenter.cost_center.id == login.costCenter
        // )

        if (selectedDepartment) {
          localStorage.setItem('department', JSON.stringify(selectedDepartment.department))
        }
        // if (selectedCostCenter) {
        //   localStorage.setItem('costCenter', JSON.stringify(selectedCostCenter.cost_center))
        // }
        if (glAccountList.length > 0) {
          const mappedGlAccount = glAccountList.map(glAccount => glAccount.general_ledger_account)
          localStorage.setItem('glAccount', JSON.stringify(mappedGlAccount))
        }

        let redirectUrl = localStorage.getItem('redirectUrl')

        if (redirectUrl) {
          localStorage.removeItem('redirectUrl')
        } else {
          if (userInfo?.role === 'requestor') {
            redirectUrl = '/'
          } else {
            redirectUrl = '/orders'
          }
        }

        window.location.href = redirectUrl
      }
    }
    setOpen1(false)
  }

  useEffect(() => {
    i18n.changeLanguage(JSON.parse(localStorage.getItem('Language')))
  }, [])

  useEffect(() => {
    // check remember me
    if (cookies.get('remember') == 'true') {
      setLogin({
        user: cookies.get('user'),
        password: cookies.get('password')
      })

      setCheck(true)
    }
  }, [])

  useEffect(() => {
    document.body.style.backgroundColor = '#fff'
  }, [])

  const loginStyles = loginUseStyles()

  let disabledButton = !userInfo || login.user == '' || login.password == ''
  if (!loadingUserInfo && userInfo?.role === 'requestor') {
    if (login.department == '' || login.costCenter == '') {
      disabledButton = true
    }
  }

  return (
    <div className={loginStyles.body}>
      {loadingUserInfo && (
        <div
          style={{
            background: 'rgba(0,0,0,0.3)',
            width: '100%',
            height: '100vh',
            position: 'fixed',
            zIndex: 9999,
            left: 0,
            top: 0
          }}
        >
          <Loading />
        </div>
      )}
      <div className={loginStyles.boxContainer}>
        <div className={loginStyles.logoWrapper}>
          <img src='/logo-icon.png' />
          <h2>Exceliconstore</h2>
        </div>
        <p className={loginStyles.infoLogin}>
          Welcome to Exceliconstore <br />
          Please login to continue
        </p>
        <form className={loginStyles.formGroup} onSubmit={Login}>
          <div className={loginStyles.formControl}>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              id='email'
              name='user'
              placeholder='Enter email'
              value={login.user}
              onChange={handleChangeLogin}
              onBlur={() => {
                handleGetInfo()
                handleGetDepartment()
                // handleGetCostCenter()
                handleGetGLAccount()
              }}
            />
          </div>
          <div className={loginStyles.formControl}>
            <label htmlFor='password'>Password</label>
            <div className={loginStyles.passwordInput}>
              <input
                id='password'
                type={showPassword ? 'text' : 'password'}
                name='password'
                placeholder='Enter password'
                value={login.password}
                onChange={handleChangeLogin}
              />
              <IconButtonStyled
                aria-label='toggle password visibility'
                onClick={handleClickShowPassword}
                edge='end'
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButtonStyled>
            </div>
          </div>
          {userInfo?.role === 'requestor' && (
            <>
              <div className={loginStyles.formControl}>
                <label htmlFor='department'>Departement</label>
                <select
                  id='department'
                  name='department'
                  onChange={handleChangeLogin}
                  value={login.department}
                >
                  <option>{loadingDepartment ? 'Loading...' : '-- Choose one --'}</option>
                  {departmentList.map(department => (
                    <option key={department.department.id} value={department.department.id}>
                      {department.department.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className={loginStyles.formControl}>
                <label htmlFor='costCenter'>Cost Center</label>
                <select
                  id='costCenter'
                  name='costCenter'
                  onChange={handleChangeLogin}
                  value={login.costCenter}
                >
                  <option>{loadingCostCenter ? 'Loading...' : '-- Choose one --'}</option>
                  {costCenterList.map(costCenter => (
                    <option key={costCenter.cost_center.id} value={costCenter.cost_center.id}>
                      {costCenter.cost_center.name}
                    </option>
                  ))}
                </select>
              </div> */}
            </>
          )}
          <Box sx={{ textAlign: 'right' }}>
            <Link>
              <a href='/forgot-password'>Forgot Password</a>
            </Link>
          </Box>
          <button type='submit' disabled={disabledButton} className={loginStyles.button}>
            {open1 === true ? (
              <div style={{ paddingTop: '3px' }}>
                <BeatLoader size={12} color={'white'} />
              </div>
            ) : (
              'LOGIN'
            )}
          </button>
        </form>
      </div>
      {loginMessage && (
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          open={loginMessage}
          autoHideDuration={6000}
          onClose={() => {
            setloginMessage(false)
            setloginMessageValue('')
          }}
          message={loginMessageValue}
          action={
            <Button
              color='secondary'
              size='small'
              onClick={() => {
                setloginMessage(false)
                setloginMessageValue('')
              }}
            >
              OK
            </Button>
          }
        />
      )}
    </div>
  )
}
export default withNamespaces()(Form)
